import { render, staticRenderFns } from "./Belege.vue?vue&type=template&id=3178196b"
import script from "./Belege.vue?vue&type=script&lang=js"
export * from "./Belege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports